// extracted by mini-css-extract-plugin
module.exports = {"root":"R5wpmScdrCwlb54Urck8"};